// extracted by mini-css-extract-plugin
export default {"displayBox":"InformationDisplay_displayBox__YJ3ka","label":"InformationDisplay_label__zYtWx"};